// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6fc3d38a","893":"62a96cf0","976":"fb291aa8"}[chunkId] + ".chunk.js";
};